<template>
    <div v-if="form!==undefined">
        <!-- Section : Logo -->
        <div class="logo-section">
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <img src="https://cdn.redgirasol.com/mail/logo1.png" alt="Header Logo">
                </div>
            </div>
        </div>
        <!-- end Section : Logo -->

        <!-- Section : Banner -->
        <div class="banner-section">
            <div class="row">
                <div class="col-md-12">
                    <img :src="getFullImg" alt="Header Logo">
                </div>
            </div>
        </div>
        <!-- end 500px box -->

        <!-- Section : Contact -->
        <div class="contact-section">
            <div class="row">
                <div class="col-md-3">
                    <img src="https://cdn.redgirasol.com/mail/mano_icono.png" alt="Icon">
                </div>
                <div class="col-md-9">
                    <h3 class="sm-hero-text">
                        ¡No te dejes engañar!
                    </h3>
                    <p>
                        RedGirasol nunca te solicitará por correo tu usuario y/o contraseña.
                        Por tu seguridad confirma que las ligas o botones de cualquier
                        correo
                        te lleven al sitio de
                        <span>redgirasol.com</span>
                        antes de dar clic.
                    </p>
                </div>
            </div>
        </div>
        <!-- end Section : Contact -->

        <!-- Section : Contact -->
        <div class="contact-section">
            <div class="row">
                <div class="col-md-3">
                    <img src="https://cdn.redgirasol.com/mail/dudas_icono.png" alt="Icon">
                </div>
                <div class="col-md-9">
                    <h3 class="sm-hero-text">
                        ¿Tienes dudas?
                    </h3>
                    <p>
                        Contáctanos a través del chat en
                        <span>redgirasol.com</span>
                        o en cualquiera de nuestras redes sociales.
                    </p>
                </div>
            </div>
        </div>
        <!-- end Section : Contact -->

        <!-- Section : Footer -->
        <div class="footer-section">
            <div class="row">
                <div class="col-md-12 footer-social">
                     <a class="col-sm-3"
                        href="https://www.facebook.com/redgirasol/">
                        <img src="https://cdn.redgirasol.com/mail/facebook.png"
                            alt="facebook" style="width: 17px;">
                    </a>
                    <a class="col-sm-3" href="https://twitter.com/redgirasol">
                        <img src="https://cdn.redgirasol.com/mail/twitter.png"
                            alt="twitter" style="width: 17px;">
                    </a>
                    <a class="col-sm-3"
                        href="https://www.instagram.com/redgirasol/">
                        <img src="https://cdn.redgirasol.com/mail/instagram.png"
                            alt="instagram" style="width: 17px;">
                    </a>
                    <a class="col-sm-3"
                        href="https://www.linkedin.com/company/10346607/">
                        <img src="https://cdn.redgirasol.com/mail/linkedin.png"
                            alt="linkedin" style="width: 17px;">
                    </a>
                </div>
                <div class="spacer"></div>
                <div class="col-md-12 mb-2">
                    <a href='https://redgirasol.com'>
                        <img src="https://cdn.redgirasol.com/mail/logo_gris.png" alt="logo Footer">
                    </a>
                </div>
                <div class="col-md-12 footer-text">
                    <p>
                        <span>© Red
                            Girasol S.A.P.I. de C.V. 2021</span> |
                        <a href='https://www.redgirasol.com/aviso-de-privacidad'>
                            Aviso de Privacidad
                        </a> |
                        <a href='https://www.redgirasol.com/terminos-y-condiciones'>
                            Términos y Condiciones
                        </a>
                    </p>
                </div>
                <div class="spacer"></div>
                <div class="col-md-12 footer-text">
                    <p>
                        <span>¿Quieres configurar las notificaciones que recibes de nuestra parte?</span>
                    </p>
                    <a href="#">
                        Administra tus notificaciones.
                    </a>
                </div>
            </div>
        </div>
        <!-- end Section : Footer -->
    </div>
</template>

<script>
    export default {
        name: 'MoldTemplate3',
        props: {
            value: {
                type: Object
            },
        },
        data: () => ({
            form: {
                subject: '¡Tus inversiones están brillando!',
                fullImg: 'https://i0.wp.com/elfutbolito.mx/wp-content/uploads/2019/04/image-not-found.png',
                fullImgHref: '',
            },
            mold: {
                dynamic: {
                    0: {
                        key: '<<1>>',
                    },
                },
            },

        }),
        mounted() {
            if (this.value !== undefined) {
                this.form = this.value;
            }
        },
        methods: {},
        computed: {
            getFullImg(){
                return `https://cdn.redgirasol.com/${this.form.fullImg}`;
            },
        },
        watch: {
            value: function (newForm, oldForm) {
                this.form = newForm;
            }
        }
    }
</script>

<style lang="scss">
    .logo-section {
        display: block;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        background-color:#FAFAFA;
        padding: 20px 50px;

        img {
            width: 100%;
            border: 0;
        }
    }

    .banner-section {
        display: block;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        background-color:#FAFAFA;

        img {
            width: 100%;
            border: 0;
        }
    }

    .content-section {
        display: block;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        background-color:#FFF;
        padding: 40px;
        
        .content-greeting {
            padding: 0 15px;
            margin-bottom: 15px;
        }

        .content-subject {
            padding: 0 15px;
            
            p {
                font-size: 16px;
                line-height: 26px;
                color: #626262;
                font-weight: 400;
            }
        }

        .content-text {
            padding: 0 15px;
        }

        .content-action {
            padding: 0 15px;

            a {
                text-align: center;
                font-family: Roboto, Arial, sans-serif;
                color: rgb(255, 255, 255);
                font-weight: 300;
                display: block;
                font-size: 16px;
                padding: 13px 20px;
                text-decoration: none;
                border-radius: 3px;
                line-height: 100%;
                background-color: rgb(249, 160, 27);
            }

            a:hover {
                color: rgb(255, 255, 255);
            }
        }
    }

    .contact-section {
        border-top: 1px solid rgb(241, 241, 241);
        display: block;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        background-color:#FFF;
        padding: 40px;

        .sm-hero-text {
            font-family: Montserrat, Helvetica, sans-serif;
            font-size: 16px;
            line-height: 16px;
            font-weight: 500;
            color: rgb(41, 41, 41);
            margin: 0px 0px 10px;
        }

        p {
            font-family: Roboto, Arial, sans-serif;
            font-size: 13px;
            line-height: 16px;
            font-weight: 300;
            color: rgb(126, 126, 126);
            margin: 0px;

            span {
                font-family: Montserrat, Arial, sans-serif;
                font-size: 13px;
                line-height: 16px;
                font-weight: 500;
                color: rgb(41, 41, 41);
            }
        }
    }

    .footer-section {
        display: block;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        background-color:rgb(245, 245, 245);
        padding: 30px;

        .footer-social {
            a {
                text-decoration: none;
                padding-right: 10px;
            }
        }

        .footer-text {
            p {
                font-family: Roboto, Arial, sans-serif;
                font-size: 11px;
                line-height: 22px;
                font-weight: 300;
                color: rgb(126, 126, 126);
                margin: 0px;

                span {
                    color: rgb(126, 126, 126);
                }
            }

            a {
                color: rgb(41, 41, 41);
                margin: 0px;
                font-weight: 500;
                text-decoration: none;
                font-size: 11px;
            }
        }

        .spacer {
            margin: 20px auto;
            width: 90%;
            background: rgb(208, 216, 222);
            height: 1px;
            line-height: 1px;
        }
    }

    .vx-card {
        .vx-card__collapsible-content {
            img {
                display: inline;
            }
        }
    }
</style>